import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment'
import adicionarFiltroManuntecaoVeiculo from '../../actions/manutencao-veiculo/adicionarFiltroManutencaoVeiculo'
import removerFiltroManutencaoVeiculo from '../../actions/manutencao-veiculo/removerFiltroManutencaoVeiculo'
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaManutencaoVeiculo extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isCpf={this.props.isCpf}
        isNome={this.props.isNome}
        isRadio={this.props.isRadio}
        isFiltroData={this.props.isFiltroData}
        isFiltroHora={this.props.isFiltroHora}
        isNumero={this.props.isNumero}
        adicionarFiltro={this.props.adicionarFiltroManuntecaoVeiculo}
        removerFiltro={this.props.removerFiltroManutencaoVeiculo}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosManutencaoVeiculo
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroManuntecaoVeiculo,
    removerFiltroManutencaoVeiculo,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaManutencaoVeiculo)

